<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 24" class="design-iconfont">
    <path
      d="M13.8431 1.14248C14.6564 1.93792 14.7145 3.1923 14.0174 4.0533L13.8431 4.24463L5.91455 11.9997L13.8431 19.7554C14.6564 20.5508 14.7145 21.8052 14.0174 22.6662L13.8431 22.8575C13.0299 23.653 11.7475 23.7098 10.8672 23.028L10.6716 22.8575L1.15685 13.5511C0.343607 12.7556 0.285517 11.5013 0.982587 10.6402L1.15685 10.4489L10.6716 1.14248C11.5474 0.285841 12.9673 0.285841 13.8431 1.14248Z"
      fill="#fff" />
  </svg>
</template>